export const Loader = () => {
  return (
    <div className="loading-overlay">
      <div className="overlay-loader"></div>
      <div className="loading-text">Please wait...</div>
    </div>
  );
};
